module.exports = __webpack_public_path__ + "static/media/icons8-table-properties.2faf3bb0.svg";